import React from 'react'
import styled, { css } from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import Brand from 'helpers/brand'

import { useServerErrorContext } from 'hooks/ServerErrorContext'

import { color } from 'styles/colors'
import { screenSize, screenWidthBreakpoints } from 'styles/shared'

const ServerErrorBanner = () => {
  const { serverError, setServerError } = useServerErrorContext()

  if (!serverError) {
    return null
  }

  const instructions = `First try reloading the page in your browser, then contact ${Brand.productName()} support if this does not resolve the issue.`

  return (
    <S.Container>
      <S.Content>
        <S.Details>
          <S.Icon>
            <S.IconBackground className="icon-circle" />
            <S.IconForeground className="icon-notification" />
          </S.Icon>

          <S.Text>
            <b>An error has occurred on the server</b>
            <div>{new Date().toString()}</div>
            <div>Error Cause: {serverError || 'unknown'}</div>
          </S.Text>
        </S.Details>

        <S.Message>{instructions}</S.Message>

        <S.Controls>

          <Button decoration="secondary" text="Ok" onPress={() => { setServerError(null) }} />
        </S.Controls>
      </S.Content>
    </S.Container>
  )
}

export default ServerErrorBanner

const columnStyle = css`
  display: flex;
  align-items: center;
  height: 100px;

  @media ${screenSize.small} {
    height: 50px;
    margin-bottom: 15px;
    justify-content: center;
  }
`

const S = {
  Container: styled.div`
    background: ${color('serverErrorBannerBackground')};
    border-bottom: 1px solid ${color('border')};
  `,
  Content: styled.div`
    max-width: ${screenWidthBreakpoints.maxLarge}px;
    margin: auto;
    padding: 0 30px 0 30px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    @media ${screenSize.small} {
      display: block;
      padding-top: 15px;
    }
  `,
  Details: styled.div`
    ${columnStyle}
  `,
  Icon: styled.div`
    margin-right: 12px;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    font-size: 1.6rem;
    color: ${color('imageCaptionText')};
  `,
  IconBackground: styled.div`
    color: ${color('errorText')}
  `,
  IconForeground: styled.div`
    position: absolute;
    left: -2px;
    top: 0;
  `,
  Text: styled.div`
    display: inline-block;
    vertical-align: middle;
    line-height: normal;

    @media ${screenSize.small} {
      text-align: center;
    }
  `,
  Message: styled.div`
    ${columnStyle}

    font-weight: bold;
    text-align: center;
  `,
  Controls: styled.div`
    ${columnStyle}

    justify-content: right;
  `
}
